import { FaStar } from "react-icons/fa6";
import DesktopLanding from "../../../../assets/images/svgs/Desktop landing.svg";
import { FaCaretDown } from "react-icons/fa";
import { TranslateText } from "../../../../utils/translation";

const Preview = ({ localHotelDetailsState }) => {
  const getInitials = (name) => {
    const parts = name?.split(" ");
    let initials = "";

    if (Array.isArray(parts)) {
      if (parts?.length === 1) {
        // If only one part, take the first character
        initials = parts?.[0].charAt?.(0);
      } else if (parts?.length > 1) {
        // If multiple parts, take the first character of the first part
        // and the first character of the last part
        initials = Boolean(parts?.[1]?.charAt?.(0))
          ? parts?.[0].charAt?.(0) + parts?.[1]?.charAt?.(0)
          : parts?.[0].charAt?.(0);
      }

      return Boolean(initials) ? initials?.toUpperCase() : ""; // Convert to uppercase if needed
    } else return "";
  };

  function formatNumber(number, randomNumber) {
    if (!Boolean(number)) return Math.ceil(10 * randomNumber);
    else if (number < 50) return number * 10;
    else if (number >= 10000000)
      return (number / 10000000).toFixed(0) + " Cr +";
    else if (number >= 100000) return (number / 100000).toFixed(0) + " L +";
    else if (number >= 1000) return (number / 1000).toFixed(0) + " K +";
    else return number;
  }

  let coverIMG = localHotelDetailsState?.coverImage;

  const hotelInitials = getInitials(localHotelDetailsState?.name);

  let dynamicCustomerData = [
    {
      title: "Checked-in through hotel -X",
      value: formatNumber(
        localHotelDetailsState?.totalCustomers,
        Math.random() * 10
      ),
    },
    {
      title: "Rating from Customer",
      value: localHotelDetailsState?.reviewRate?.toFixed(1) || 4,
    },
    {
      title: "Quick QR express check-in experience.",
      value: formatNumber(
        localHotelDetailsState?.expressCheckInCount,
        Math.random() * 10
      ),
    },
  ];

  return (
    <section
      className=" bg-custom-gradient flex justify-center items-center  relative "
      id="Home"
      style={{
        backgroundImage: `url(${coverIMG})`,
        backgroundSize: "cover",
        height: "500px",
        width: "100%",
        backgroundPosition: "center",
        filter: "blur(0.3px)",
      }}
    >
      {!localHotelDetailsState?.coverImage && (
        <div className="w-[100%] h-[100%]">
          <img src={DesktopLanding} className="w-[100%] h-[100%]" alt="" />
        </div>
      )}
      <div className="absolute inset-0 bg-black opacity-[0.4] filter blur-[13px]" />

      <div className="absolute top-0 w-[100%] bg-black/50 shadow-custom text-fg-inverse flex justify-between items-center py-3 px-[60px]">
        <div>
          <div className="w-[46px] h-[46px] rounded-full overflow-hidden">
            {Boolean(localHotelDetailsState?.logo) ? (
              <div className="w-[36px] h-[36px] rounded-full overflow-hidden">
                <img
                  src={localHotelDetailsState?.logo}
                  alt=""
                  className="w-full h-full object-cover"
                />
              </div>
            ) : (
              <>
                {" "}
                <button
                  className="w-[36px] h-[36px] rounded-[50%] whitespace-nowrap
                          border border-surface text-fg-inverse  text-[12px] font-semibold uppercase"
                >
                  {hotelInitials}
                </button>
              </>
            )}
          </div>
        </div>

        <div className="flex items-center gap-4">
          <a
            className="font-body font-[400] text-[18px] leading-[27px] text-fg-inverse"
            href="#About"
          >
            
            <TranslateText
                      textKey={"about"}
                      namespace="profile"
                    />
          </a>
        
          <div className="font-body font-[400] text-[18px] leading-[27px] text-fg-inverse cursor-pointer">
            
            <TranslateText
                      textKey={"contact_us"}
                      namespace="profile"
                    />
          </div>
        </div>
      </div>

      <div className="absolute top-[21.58%] left-[6.5%] w-[100%] flex flex-col justify-center items-start mx-auto px-auto">
        <div className=" font-body font-[600] text-[34px] leading-[26.8px] text-fg-inverse">
          
          <TranslateText
                      textKey={"book_now_for_the"}
                      namespace="profile"
                    />
        </div>

        <div className="img-slider">
          <div className="">
            <div className="slide font-body font-[600]  text-[24px]  leading-[40.8px] text-accent">
             
              <TranslateText
                      textKey={"guaranteed_room_reservation_at_the_hotel"}
                      namespace="profile"
                    />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute w-[100%] flex gap-[100px] top-[53.23%] left-[7.66%] items-center ">
        {dynamicCustomerData?.map((Obj, index) => {
          return (
            <div className="flex flex-col items-start" key={Obj?.title}>
              <div className="font-body font-[600] text-[34px] leading-[30px] text-fg-inverse whitespace-nowrap flex items-center">
                {index === 1 && <FaStar className="text-[24px]  gap-2" />}{" "}
                <span className="pl-2 font-body font-[500] text-[34px] leading-[30px] text-fg-inverse">
                  {Obj?.value}
                </span>
              </div>
              <div className="font-body font-[400] text-[14px] leading-[30px] text-fg-inverse">
                {Obj?.title}
              </div>
            </div>
          );
        })}
      </div>

      <div className=" absolute bottom-[10%] left-[7.66%] right-[6.6%] bg-surface rounded-[8px] flex justify-between items-center py-[12px] px-[20px] border border-black">
        <div className="flex flex-col gap-0">
          <div className="font-body font-[400] text-[16px] leading-[30px] text-fg-secondary">
            
            <TranslateText
                      textKey={"check_in"}
                      namespace="profile"
                    />
          </div>
          <div className="font-body font-[600] text-[16px] leading-[30px] text-neutral-800">
            20<TranslateText
                      textKey={"feb"}
                      namespace="profile"
                    /> 2024
            
          </div>
        </div>

        <div className="flex gap-[10px] items-end justify-end  ">
          <FaCaretDown className="text-neutral-800 text-[14px]" />

          <div className="border-neutral-400 h-[40px] border-[1px] opacity-[30%] "></div>

          <div className="flex flex-col gap-0">
            <div className="font-body font-[400] text-[16px]  text-fg-secondary">
              
              <TranslateText
                      textKey={"check_out"}
                      namespace="profile"
                    />
            </div>
            <div className="font-body font-[600] text-[16px] text-neutral-800">
              20 <TranslateText
                      textKey={"feb"}
                      namespace="profile"
                    /> 2024

            </div>
          </div>
        </div>

        <div className="flex gap-[10px] items-end justify-end  ">
          <FaCaretDown className="text-neutral-800 text-[14px]" />

          <div className="border-neutral-400 h-[40px] border-[1px] opacity-[30%] "></div>

          <div className="flex flex-col gap-0">
            <div className="font-body font-[400] text-[16px]  text-fg-secondary">
              
              <TranslateText
                      textKey={"guest"}
                      namespace="profile"
                    />
            </div>
            <div className="font-body font-[600] text-[16px] text-neutral-800">
              2
              <TranslateText
                      textKey={"guest"}
                      namespace="profile"
                    /> 
              
            </div>
          </div>
        </div>

        <div className="flex gap-[16px] items-end ">
          <FaCaretDown className="text-neutral-800 text-[10px]" />
          <div className="flex justify-center items-center bg-black rounded-[8px] font-body font-[600] text-[16px] leading-[30px] text-fg-inverse p-[12px]">
            
            <TranslateText
                      textKey={"book_now"}
                      namespace="profile"
                    /> 
          </div>
        </div>
      </div>
    </section>
  );
};

export default Preview;
